<app-header role="banner" data-headroom itemscope itemtype="https://schema.org/WPHeader"></app-header>
<app-hero itemscope itemprop="primaryImageOfPage"></app-hero>
<main class="wrap" role="main" itemscope itemprop="mainContentOfPage" itemtype="http://schema.org/Blog">
  <router-outlet></router-outlet>
</main>
<app-footer role="contentinfo" itemscope itemtype="https://schema.org/WPFooter"></app-footer>
